<script>
import TablePage from '@/found/components/table_page';

export default {
  name: 'details_table',
  extends: TablePage,
  data() {
    return {
      params: {},
    };
  },
  props: {
    propsObj: Object,
  },
  async created() {
    console.log(this.propsObj);
    this.params = { feePoolCode: this.propsObj.row.feePoolCode };
    await this.getConfigList('customer_channel_fee_pool_record_list');
  },
  methods: {

  },
};
</script>
